<template>
  <div class="rmsdMatrix" id="rmsdMatrix" style="overflow:scroll">
    {{msg}}
    <div class="col form-group">
      <label for="top">Value above diagonal</label>
      <select class="form-control" id="top" name="top" size="1" v-model="top" @change="render()">
        <option v-for="(value, index) in categories" :key="index" :value="index">{{ value.name }}</option>
      </select>
    </div>
    <div class="col form-group">
      <label for="bottom">Value below diagonal</label>
      <select
        class="form-control"
        id="bottom"
        name="bottom"
        size="1"
        v-model="bottom"
        @change="render()"
      >
        <option v-for="(value, index) in categories" :key="index" :value="index">{{ value.name }}</option>
      </select>
    </div>

    <div class="col form-group">
      <label for="order">Order by</label>
      <select
        class="form-control"
        id="order"
        name="order"
        size="1"
        v-model="order"
        @change="render()"
      >
        <option v-for="(value, index) in orders" :key="index" :value="index">{{ value }}</option>
      </select>
    </div>
    <svg id="rmsdMatrixSVG" :height="height" :width="width" />
    <div id="rmsdTooltip" class="matrix_tooltip hidden"></div>
    <div id="labelsTooltip" class="matrix_tooltip hidden">
      <div v-if="hoveredPDBInfo">
        {{hoveredPDBInfo.name}}
        <table width="100%">
          <tr>
            <th>Member of cluster</th>
            <td>
              <span
                :style="{'color': hoveredPDBInfo.master.color, 'font-size':'18px'}"
                aria-label="Cluster color label"
              >
                <i class="fas fa-square"></i>
              </span>
            </td>
            <td>{{hoveredPDBInfo.master.label}}</td>
          </tr>
          <tr>
            <th>UniprotID</th>
            <td></td>
            <td>{{hoveredPDBInfo.uniprotId || 'Unknown'}}</td>
          </tr>

          <tr>
            <th>Ligands</th>
            <td>
              <span
                v-if="hoveredPDBInfo.ligands && hoveredPDBInfo.ligands.length > 0"
                :style="{'color': 
                ui.annotation.colors.ligand, 'font-size':'18px'}"
                aria-label="Heterocomplex color label"
              >
                <i class="fas fa-check-square"></i>
              </span>
              <span
                v-else
                :style="{'color': 
                ui.annotation.colors.default, 'font-size':'18px'}"
                aria-label="Heterocomplex color label"
              >
                <i class="fas fa-square"></i>
              </span>
            </td>
            <td>
              <span v-if="hoveredPDBInfo.ligands && hoveredPDBInfo.ligands.length > 0">
                <span v-for="(l, index) in hoveredPDBInfo.ligands" v-bind:key="index">
                  {{l}}
                  <br />
                </span>
              </span>
              <span v-else>None</span>
            </td>
          </tr>
          <tr>
            <th>Part of the heterocomplex</th>
            <td>
              <span
                v-if="hoveredPDBInfo.isComplex"
                :style="{'color': 
                ui.annotation.colors.complex, 'font-size':'18px'}"
                aria-label="Heterocomplex color label"
              >
                <i class="fas fa-check-square"></i>
              </span>
              <span
                v-else
                :style="{'color': 
                ui.annotation.colors.default, 'font-size':'18px'}"
                aria-label="Heterocomplex color label"
              >
                <i class="fas fa-square"></i>
              </span>
            </td>
            <td>{{hoveredPDBInfo.isComplex? "yes": "no"}}</td>
          </tr>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "RMSDMatrix",
  props: {
    heatmap: Object
  },
  data: function() {
    return {
      width: "100%",
      height: "200px",
      msg: "",
      categories: {
        cm_overlap: {
          name: "Contact map overlap [0-1]",
          colorMin: "yellow",
          colorMax: "darkorange"
        },
        rmsd: { name: "C⍺RMSD [Å]", colorMin: "red", colorMax: "pink" },
        seq_id: {
          name: "Sequence identity [%]",
          colorMin: "greenyellow",
          colorMax: "green"
        },
        n_res: {
          name: "Number of aligned residues",
          colorMin: "lightblue",
          colorMax: "blue"
        }
      },
      order: "original",
      orders: {
        original: "Original",
        // h_rmsd: "RMSD : Hierarchical",
        ligand: "By ligand",
        complex: "By heterocomplex status"
        //     kmeans_rmsd: "RMSD : k-means"
      },
      top: "rmsd",
      bottom: "rmsd",
      ui: {
        margin: {
          top: 15,
          right: 0,
          bottom: 5,
          left: 15
        },
        gridMin: 20,
        gridMax: 100,
        gridGap: 1,
        //----- sum those to calc nonGridWidth
        labelsWidth: 35, //width of the labels
        labelsGap: 5, // between labels ann annotations bars
        annotationsWidth: 6, // annotations bar width, *2
        annotationsGap: 2, // between bars and grid
        //--- recalculated in mounted() hook
        nonGridWidth: 51,
        annotation: {
          // annotation bar
          colors: {
            default: "lightgrey",
            ligand: "#F39C12",
            complex: "#6610f2"
          }
        }
      },
      hoveredPDBInfo: null
    };
  },
  mounted() {
    const self = this;
    self.ui.nonGridWidth =
      self.ui.labelsWidth +
      self.ui.labelsGap +
      self.ui.annotationsWidth * 2 +
      self.ui.annotationsGap;

    this.render();

    window.jQuery(window).resize(function() {
      self.render();
    });

    let maxRMSDpair = this.heatmap.heatmap[0];
    this.heatmap.heatmap.forEach(p => {
      if (p.rmsd === self.heatmap.max.rmsd) maxRMSDpair = p;
    });

    this.heatmap.heatmap && this.selectPair(maxRMSDpair);
  },
  watch: {
    heatmap: {
      deep: false,
      handler() {
        // console.log(newData);
        this.render();
      }
    }
  },
  methods: {
    log: function(msg) {
      console.log("[RMSDMatrix] " + msg);
    },
    calculateVizualIndices: function() {
      let res = {};
      const self = this;

      switch (this.order) {
        case "h_rmsd": {
          let orders = this.hcluster("rmsd");
          this.heatmap.labels.forEach((l, i) => (res[l] = orders[i]));
          break;
        }
        case "ligand": {
          let flagged = this.heatmap.labels
            .map(l => {
              return {
                lbl: l,
                flag: self.heatmap.pmap[l].info.ligands.length > 0 ? 1 : 0
              };
            })
            .sort(function(a, b) {
              return b.flag - a.flag;
            });
          flagged.forEach((l, i) => (res[l.lbl] = i));
          break;
        }
        case "complex": {
          let flagged = this.heatmap.labels
            .map(l => {
              return {
                lbl: l,
                flag: self.heatmap.pmap[l].info.isComplex ? 1 : 0
              };
            })
            .sort(function(a, b) {
              return b.flag - a.flag;
            });
          flagged.forEach((l, i) => (res[l.lbl] = i));
          break;
        }

        default: {
          // original order
          this.heatmap.labels.forEach((l, i) => (res[l] = i));
        }
      }
      // console.log(res)
      return res;
    },
    render: function() {
      window.jQuery("#rmsdMatrixSVG").empty();
      window.jQuery("#rmsdTooltip").empty();

      if (!this.heatmap || !this.heatmap.heatmap) {
        this.log("No data provided");
        return;
      }

      const d3 = window.d3;
      let svg = d3.select("#rmsdMatrixSVG");

      if (!svg) {
        this.log("No svg?");
        return;
      }

      // map of pdbid - index
      let visualIndices = this.calculateVizualIndices();

      const self = this;
      const W = window.jQuery("#rmsdMatrix").width() || 400;

      let width = W - this.ui.margin.left - this.ui.margin.right; // total drawing width
      let matrixWidth = width - self.ui.nonGridWidth; //matrix area without labels

      let gridSize = Math.min(
        this.ui.gridMax,
        Math.max(
          this.ui.gridMin,
          Math.floor(matrixWidth / (this.heatmap.labels.length + 0.3))
        )
      );
      let height = width;

      const getCardLabel = function(d) {
        return d.pdbInfo1.name + ":" + d.pdbInfo2.name;
      };

      const svgview = svg
        .attr("width", width + this.ui.margin.left + this.ui.margin.right)
        .attr("height", height + this.ui.margin.top + this.ui.margin.bottom)
        .append("g")
        .attr(
          "transform",
          "translate(" + this.ui.margin.left + "," + this.ui.margin.top + ")"
        );

      let gLabels = svgview.append("g");

      self.renderAxisLabels(gLabels, gridSize, visualIndices);

      // Colors for two parts of the matrix
      let colorScaleTop = d3
        .scaleSequential()
        .interpolator(
          d3.interpolate(
            this.categories[self.top].colorMin,
            this.categories[self.top].colorMax
          )
        )
        .domain([this.heatmap.min[self.top], this.heatmap.max[self.top]]);
      let colorScaleBottom = d3
        .scaleSequential()
        .interpolator(
          d3.interpolate(
            this.categories[self.bottom].colorMin,
            this.categories[self.bottom].colorMax
          )
        )
        .domain([this.heatmap.min[self.bottom], this.heatmap.max[self.bottom]]);

      // create a tooltip
      const tooltip = d3.select("#rmsdTooltip").style("opacity", 0);

      const DY = 290,
        DX = 80;
      // Three function that change the tooltip when user hover / move / leave a cell
      const mouseover = function(d) {
        tooltip
          .style("opacity", 1)
          .style("display", "block")
          .style("left", d3.event.pageX + DX + "px")
          .style("top", d3.event.pageY + DY + "px");

        if (!d) {
          d3.select(this)
            .selectAll("rect")
            .classed("hoveredPair", true);
        } else {
          // has data;
          d3.select("#card_" + d.pdbInfo1.name + "_" + d.pdbInfo2.name).classed(
            "hoveredPair",
            true
          );
          d3.select("#card_" + d.pdbInfo2.name + "_" + d.pdbInfo1.name).classed(
            "hoveredPair",
            true
          );
        }
      };

      const mousemove = function(d) {
        const c = self.categories;
        const yn = d.modDDMURL ? "yes" : "no";
        tooltip
          .html(
            `<b>${d.pdbInfo1.name}:${d.pdbInfo2.name}</b><table>
          <tr><th>${c.rmsd.name}</th><td> ${d.rmsd}</td></tr>
          <tr><th>${c.seq_id.name}</th><td> ${d.seq_id}</td></tr>
          <tr><th>${c.cm_overlap.name}</th><td> ${d.cm_overlap}</td></tr>
          <tr><th>${c.n_res.name}</th><td> ${d.n_res}</td></tr>
          <tr><th>Model is ready</th><td> ${yn}</td></tr>
          </table>`
          )
          .style("left", d3.mouse(this)[0] + DX + "px")
          .style("top", d3.mouse(this)[1] + DY + "px");
      };
      const mouseleave = function() {
        tooltip.style("opacity", 0);
        tooltip.style("display", "none");
        d3.select(this)
          .selectAll("rect")
          .classed("hoveredPair", false);
      };

      const grid = svgview
        .append("g")
        .attr("id", "matrix_grid")
        .attr(
          "transform",
          "translate(" + self.ui.nonGridWidth + "," + self.ui.nonGridWidth + ")"
        );

      let gCards = grid.append("g").attr("id", "matrix_cards");

      const fullData = this.heatmap.heatmap;

      let cards = gCards.selectAll(".card").data(fullData);

      let selection = cards.enter();
      let g = selection.append("g");

      const gap = this.ui.gridGap;
      const cellSize = gridSize - 2 * gap;

      // above the diagonal
      g.append("rect")
        .attr("id", function(d) {
          return "card_" + d.pdbInfo1.name + "_" + d.pdbInfo2.name;
        })
        .attr("x", function(d) {
          let v1 = visualIndices[d.pdbInfo1.name];
          let v2 = visualIndices[d.pdbInfo2.name];
          let v = Math.max(v1, v2);
          return v * gridSize + gap;
        })
        .attr("y", function(d) {
          let v1 = visualIndices[d.pdbInfo1.name];
          let v2 = visualIndices[d.pdbInfo2.name];
          let v = Math.min(v1, v2);
          return v * gridSize + gap;
        })
        .attr("rx", 4)
        .attr("ry", 4)
        .attr("class", "bordered card-top")
        .attr("width", cellSize)
        .attr("height", cellSize)
        .style("fill", function(d) {
          return colorScaleTop(d[self.top] || 0);
        });

      // //below the diagonal
      g.append("rect")
        .attr("id", function(d) {
          return "card_" + d.pdbInfo2.name + "_" + d.pdbInfo1.name;
        })
        .attr("x", function(d) {
          let v1 = visualIndices[d.pdbInfo1.name];
          let v2 = visualIndices[d.pdbInfo2.name];
          let v = Math.min(v1, v2);
          return v * gridSize + gap;
        })
        .attr("y", function(d) {
          let v1 = visualIndices[d.pdbInfo1.name];
          let v2 = visualIndices[d.pdbInfo2.name];
          let v = Math.max(v1, v2);
          return v * gridSize + gap;
        })
        .attr("rx", 4)
        .attr("ry", 4)
        .attr("class", "bordered card-bottom")
        .attr("width", cellSize)
        .attr("height", cellSize)
        .style("fill", function(d) {
          return colorScaleBottom(d[self.bottom] || 0);
        });

      g.on("mouseover", mouseover)
        .on("mousemove", mousemove)
        .on("mouseleave", mouseleave)
        .on("click", function(d) {
          self.selectPair(d);
        });

      let dLabels = grid
        .append("g")
        .attr("id", "matrix_labels")
        .selectAll(".dataLabel")
        .data(fullData, getCardLabel)
        .enter();
      let dataLabels = dLabels.append("g");

      // select font color based on background
      const getFontColor = function(d, top) {
        let c = top
          ? colorScaleTop(d[self.top])
          : colorScaleBottom(d[self.bottom]);

        let rgb = d3.rgb(c);
        //https://gomakethings.com/dynamically-changing-the-text-color-based-on-background-color-contrast-with-vanilla-js/
        // Get YIQ ratio
        var yiq = (rgb.r * 299 + rgb.g * 587 + rgb.b * 114) / 1000;

        // Check contrast
        return yiq >= 128 ? "black" : "white";
      };

      // above the diagonal
      dataLabels
        .append("text")
        .text(function(d) {
          if (self.top === "n_res") return d[self.top];
          return d[self.top].toFixed(1) || "-";
        })
        .attr("x", function(d) {
          let v1 = visualIndices[d.pdbInfo1.name];
          let v2 = visualIndices[d.pdbInfo2.name];
          let v = Math.max(v1, v2);
          return (v + 0.5) * gridSize;
        })
        .attr("y", function(d) {
          let v1 = visualIndices[d.pdbInfo1.name];
          let v2 = visualIndices[d.pdbInfo2.name];
          let v = Math.min(v1, v2);
          return (v + 0.5) * gridSize;
        })
        .attr("fill", function(d) {
          return getFontColor(d, true);
        })
        .attr("text-anchor", "middle")
        .on("mouseover", mouseover)
        .on("mousemove", mousemove)
        .on("mouseleave", mouseleave)
        .on("click", function(d) {
          self.selectPair(d);
        });

      //below the diagonal
      dataLabels
        .append("text")
        .text(function(d) {
          if (self.bottom === "n_res") return d[self.bottom];
          return d[self.bottom].toFixed(1);
        })
        .attr("x", function(d) {
          let v1 = visualIndices[d.pdbInfo1.name];
          let v2 = visualIndices[d.pdbInfo2.name];
          let v = Math.min(v1, v2);
          return (v + 0.5) * gridSize;
        })
        .attr("y", function(d) {
          let v1 = visualIndices[d.pdbInfo1.name];
          let v2 = visualIndices[d.pdbInfo2.name];
          let v = Math.max(v1, v2);
          return (v + 0.5) * gridSize;
        })
        .attr("fill", function(d) {
          return getFontColor(d, false);
        })
        .attr("text-anchor", "middle")
        .on("mouseover", mouseover)
        .on("mousemove", mousemove)
        .on("mouseleave", mouseleave)
        .on("click", function(d) {
          self.selectPair(d);
        });

      dataLabels.style("font-size", "9pt");

      cards.exit().remove();
      dataLabels.exit().remove();
    },
    renderAxisLabels: function(group, gridSize, visualIndices) {
      const self = this;
      const pdbMap = this.heatmap.pmap;
      // annotation bar
      const barLength = gridSize; ///2   - 2 * gap;
      const barsX = self.ui.labelsWidth + self.ui.labelsGap;

      const ligandColor = function(d) {
        let c = self.ui.annotation.colors.default;

        if (pdbMap[d]) {
          const i = pdbMap[d].info;
          c =
            i && i.ligands && i.ligands.length > 0
              ? self.ui.annotation.colors.ligand
              : self.ui.annotation.colors.default;
        }
        return c;
      };

      const complexColor = function(d) {
        let c = self.ui.annotation.colors.default;

        if (pdbMap[d]) {
          const i = pdbMap[d].info;
          c =
            i && i.isComplex
              ? self.ui.annotation.colors.complex
              : self.ui.annotation.colors.default;
        }
        return c;
      };

      /////////tooltip and mouse functions
      const d3 = window.d3;
      const tooltip = d3
        .select("#labelsTooltip")
        // .append("div")
        .style("opacity", 0);

      const DY = 290,
        DX = 30;

      const mouseover = function() {
        tooltip.style("opacity", 1).style("display", "block");
      };

      const mousemove = function(d) {
        if (self.hoveredPDBInfo != pdbMap[d].info) {
          self.hoveredPDBInfo = pdbMap[d].info;
        }

        tooltip
          .style("left", d3.mouse(this)[0] + DX + "px")
          .style("top", d3.mouse(this)[1] + DY + "px");
      };
      const mouseleave = function() {
        tooltip.style("opacity", 0).style("display", "none");
        self.hoveredPDBInfo = null;
      };

      ///////// vertical labels
      let yLabels = group
        .append("g")
        .attr("id", "yLabels")
        .attr("transform", function() {
          return " translate(0, " + self.ui.nonGridWidth + ")";
        })
        .selectAll(".yLabel")
        .data(self.heatmap.labels);

      let yselection = yLabels.enter();
      let yG = yselection.append("g"); // single group for label & annotations

      // cluster color label
      yG.append("rect")
        .attr("x", 0)
        .attr("y", function(d) {
          return (visualIndices[d] + 0.5) * gridSize + self.ui.annotationsGap;
        })
        .attr("width", self.ui.labelsWidth)
        .attr("height", 4)
        .attr("fill", function(d) {
          return self.heatmap.meta[d].color || "none";
        });

      // ligands bar
      yG.append("rect")
        .attr("id", function(d) {
          return "bar_y_ligand_" + d;
        })
        .attr("x", barsX)
        .attr("y", function(d) {
          return visualIndices[d] * gridSize;
        })
        .attr("width", self.ui.annotationsWidth)
        .attr("height", barLength)
        .style("fill", ligandColor);

      //complex bar
      yG.append("rect")
        .attr("id", function(d) {
          return "bar_y_complex_" + d;
        })
        .attr("x", barsX + self.ui.annotationsWidth + 1)
        .attr("y", function(d) {
          return visualIndices[d] * gridSize;
        })
        .attr("width", self.ui.annotationsWidth)
        .attr("height", barLength)
        .style("fill", complexColor);

      yG.append("text")
        .text(function(d) {
          return d;
        })
        .attr("x", 0)
        .attr("y", function(d) {
          return (visualIndices[d] + 0.45) * gridSize;
        })
        .attr("class", "mono axis") // does not apply???
        .style("font-size", "9pt")
        .style("font-family", "Consolas,courier");

      // cover for mouse events catching
      yG.append("rect")
        .attr("x", 0)
        .attr("y", function(d) {
          return visualIndices[d] * gridSize;
        })
        .attr("width", self.ui.nonGridWidth)
        .attr("height", gridSize)
        .attr("fill", "transparent");

      yG.on("mouseover", mouseover)
        .on("mousemove", mousemove)
        .on("mouseleave", mouseleave);

      ///////// horizontal labels
      let xLabels = group
        .append("g")
        .attr("id", "xLabels")
        .attr("transform", function() {
          return " translate(" + self.ui.nonGridWidth + ", 0)";
        })
        .selectAll(".xLabel")
        .data(self.heatmap.labels);

      let xselection = xLabels.enter();
      let xG = xselection.append("g");

      xG.append("rect")
        .attr("y", 0)
        .attr("x", function(d) {
          return (visualIndices[d] + 0.5) * gridSize;
        })
        .attr("width", 4)
        .attr("height", self.ui.labelsWidth)
        .attr("fill", function(d) {
          return self.heatmap.meta[d].color || "none";
        });

      // ligands bar
      xG.append("rect")
        .attr("id", function(d) {
          return "bar_x_ligand_" + d;
        })
        .attr("y", barsX)
        .attr("x", function(d) {
          return visualIndices[d] * gridSize;
        })
        .attr("height", self.ui.annotationsWidth)
        .attr("width", barLength)
        .style("fill", ligandColor);

      //complex bar
      xG.append("rect")
        .attr("id", function(d) {
          return "bar_x_complex_" + d;
        })
        .attr("y", barsX + self.ui.annotationsWidth + 1)
        .attr("x", function(d) {
          return visualIndices[d] * gridSize;
        })
        .attr("height", self.ui.annotationsWidth)
        .attr("width", barLength)
        .style("fill", complexColor);

      xG.append("text")
        .text(function(d) {
          return d;
        })
        .attr("x", "0")
        .style("text-anchor", "end")
        .attr("transform", function(d) {
          return (
            " translate(" +
            (visualIndices[d] + 0.45) * gridSize +
            ", 0) rotate(-90) "
          );
        })

        .attr("class", "mono axis")
        .style("font-size", "9pt")
        .style("font-family", "Consolas,courier");

      // cover for mouse events catching
      xG.append("rect")
        .attr("y", 0)
        .attr("x", function(d) {
          return visualIndices[d] * gridSize;
        })
        .attr("height", self.ui.nonGridWidth)
        .attr("width", gridSize)
        .attr("fill", "transparent");

      yG.on("mouseover", mouseover)
        .on("mousemove", mousemove)
        .on("mouseleave", mouseleave);

      xG.on("mouseover", mouseover)
        .on("mousemove", mousemove)
        .on("mouseleave", mouseleave);
    },
    selectPair: function(d) {
      const d3 = window.d3;
      d3.selectAll(".selectedPair").classed("selectedPair", false);

      d &&
        this.$parent // AnalysisCart.vue
          .selectPair(d);

      d3.selectAll("#card_" + d.pdbInfo2.name + "_" + d.pdbInfo1.name).classed(
        "selectedPair",
        true
      );

      d3.selectAll("#card_" + d.pdbInfo1.name + "_" + d.pdbInfo2.name).classed(
        "selectedPair",
        true
      );
    },
    hcluster: function(byValue) {
      // clusterfck needs 2d array of values
      byValue = byValue || "rmsd";
      let l = this.heatmap.labels.length;

      let arrayData = [];
      for (let i = 0; i < l; i++) {
        let row = [];
        row.length = l;
        row.fill(0);
        arrayData.push(row);
      }
      this.heatmap.heatmap.forEach(h => {
        arrayData[h.idx1][h.idx2] = h[byValue] || 0;
        arrayData[h.idx2][h.idx1] = h[byValue] || 0;
      });
      // console.log(arrayData);

      const children = function(d) {
        var l = d.left || null,
          r = d.right || null,
          res = [];
        l && res.push(l);
        r && res.push(r);

        if (res.length > 0) {
          return res;
        }
        return null;
      };

      const d3 = window.d3;
      let clusters = window.clusterfck.hcluster(arrayData);
      let tree = d3.hierarchy(clusters[0], children);
      let tree1 = d3.cluster();
      tree1(tree);

      // now leaves are ordered by cluster id
      var leaves = tree.leaves();

      // will keep index of element in original data here
      var order = [];

      leaves.forEach(function(leaf) {
        var d = leaf.data.canonical; // original row from matrix
        var i = arrayData.indexOf(d);
        order.push(i);
      });
      this.log("Data clustered (hierarchical)");

      return order;
    }
  }
};
</script>

<style >
.mono {
  font-size: 9pt;
  font-family: Consolas, courier !important;
  fill: #232222;
}
.selectedPair {
  stroke: black;
  stroke-width: 3;
  opacity: 1;
}
.hoveredPair {
  stroke: slategrey;
  stroke-width: 3;
  opacity: 1;
}
.matrix_tooltip {
  background-color: white;
  border: solid;
  border-width: 1px;
  border-radius: 5px;
  padding: 10px;
  position: absolute;
  pointer-events: none;
  z-index: 1000;
}
#labelsTooltip {
  width: 380px;
}
#rmsdTooltip {
  width: 300px;
}
</style>
